// extracted by mini-css-extract-plugin
export default {"postTitleContainer":"MbPQSQ","titleWrapper":"apmiGT","title":"H3vOVf","titleLink":"_L_svk","updateDate":"NfKpG_","topWrapper":"a5JqMF"};